// tone "light" = white lettering for dark backgrounds, "dark" = for light backgrounds.
export const Logo = ({ tone = "light", className = "h-10" }) => (
  <img
    src={tone === "light" ? "/img/logo-emma-light.png" : "/img/logo-emma.png"}
    alt="Emma Industrie — Timber Industry 1905"
    className={`block w-auto select-none ${className}`}
    draggable="false"
  />
);
